import { gql } from '@apollo/client';

export const DELETE_SAVED_JOB = gql`
  mutation DeleteSavedJob($input: DeleteSavedJobInput!, $locale: Locale) {
    deleteSavedJob2(input: $input) {
      ... on DeleteSavedJobSuccess {
        id
      }
      ... on DeleteSavedJobFailure {
        errors {
          message(locale: $locale)
        }
      }
    }
  }
`;
